import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import SignatureFile from './components'

export interface IDataPage {
  id: string | null
  type: string | null
  idDetails: string | null
  groupDomain: string | null
  refId: string | null
}

type Props = {
  dataPage: IDataPage
}

const SignaturePage: React.FC<Props> = ({dataPage}) => {
  return (
    <Switch>
      <Route path='/e_signature'>
        <SignatureFile dataPage={dataPage} />
      </Route>
      <Redirect from='/e_signature' exact={true} to='/e_signature' />
      <Redirect to='/e_signature' />
    </Switch>
  )
}
export default SignaturePage
